<template>
    <answers ref="answers"
             code_question_group="GQ31"
             danger_code="MCAL13"
             :unique_category="true"
             :show_next="showNext"
    />
</template>

<script>
import {mapState} from 'vuex';
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    },
    computed: {
        ...mapState('calculator', [
            'question_groups',
            'questions_index'
        ]),
        showNext() {
            let question_group = this.question_groups[this.questions_index];

            if (question_group) {
                let question = question_group.questions.find(q => q.code === 'QCAL200')
                return question && question.answer;
            }

            return false;
        }
    }
};
</script>
